import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceClassService } from 'app/services/models/device-class.service';
import { EnvironmentalConditionService } from 'app/services/models/environmental-condition.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-device-class-dialog',
  templateUrl: './device-class-dialog.component.html',
  styleUrls: ['./device-class-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeviceClassDialogComponent implements OnInit {
  @Input() data;
  environmentals: any[] = [];
  deviceClass: any = null;
  form: FormGroup;


  constructor(
    public ngbModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private environmentalConditionService: EnvironmentalConditionService,
    private deviceClassService: DeviceClassService) { }

  async ngOnInit() {
    await this.getAllEnvironmental();
    this.form = this.fb.group({
      name: ['', Validators.required],
      status: [true],
      environmentalConditionId: [null, Validators.required]
    });
    if (this.data) {
      await this.getByIdDeviceClass(this.data);
    }
  }

  async getByIdDeviceClass(id) {
    const data = await this.deviceClassService.getByIdDeviceClass(id);
    this.deviceClass = data;
    this.form.patchValue({
      name: this.deviceClass.name,
      status: this.deviceClass.status,
      environmentalConditionId: this.deviceClass.environmentalConditionId
    });
  }

  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }

  async getAllEnvironmental() {
    const data = await this.environmentalConditionService.getAllEnvironmentalCondition(0, 100);
    this.environmentals = data.environmental
  }

  async onSumbit() {
    if (this.form.valid) {
      console.log(this.form.value);
      if (this.data) {
        const data = await this.deviceClassService.updateDeviceClass(this.deviceClass.id,this.form.value.name, this.form.value.status, this.form.value.environmentalConditionId);
        if (data.status) {
          this.closeModal();
          this.toastrService.success(data.message);
          this.deviceClassService.sendEvent(true);
        } else {
          this.toastrService.error(data.message);
        }
      } else {
        const data = await this.deviceClassService.createDeviceClass(this.form.value.name, this.form.value.status, this.form.value.environmentalConditionId);
        if (data.status) {
          this.closeModal();
          this.toastrService.success(data.message);
          this.deviceClassService.sendEvent(true);
        } else {
          this.toastrService.error(data.message);
        }
      }

    }
  }

}
